import { VoyageRoute, VoyageRouteLineFeature, VoyageRoutePointFeature } from './voyage-routing-model'

export abstract class RouteEditModelBase extends EventTarget
{
    abstract get uiRouteIndex(): number;
    abstract editRoute(routeId: string,uiRouteIndex: number, scheduleId: string, route: VoyageRoute, setIsPassedUpdate: boolean, etd?: number, name?: string): void;
    abstract clear(): void;
    abstract setNewRoute(waypoints: VoyageRoutePointFeature[]): void;
    abstract set selectedWaypointIndex(index: number);
    abstract get selectedWaypointIndex(): number;
    abstract revert(): void;
    abstract canRevert(): boolean;
    abstract getWaypoints(): VoyageRoutePointFeature[];
    abstract saveAndCalcRoute(route: VoyageRoute): Promise<void>;
    abstract generateRouteGeometry(): Array<VoyageRoutePointFeature | VoyageRouteLineFeature>;
    abstract generateRoute(): VoyageRoute;
}

let RouteEditModel: RouteEditModelBase|null = null;

function setRouteEditModel(model: RouteEditModelBase)
{
    RouteEditModel = model;
}

export { RouteEditModel, setRouteEditModel };
